import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import moment from 'moment-mini'
import { RootState } from '../../../../store/rootReducer'
import Pagination from 'rsuite/Pagination'
import { fetchWalletHistory } from '../../../../store/member/memberSlice'
import '../../../../pages/index/pagination.sass'
import './walletTable.sass'

// @ts-ignore
const TableLine = ({ payment }: any) => {
    const [t] = useTranslation()
    return (
        <>
            <p>{moment(payment.date * 1000).format(t('time format'))}</p>
            <p>{payment.type === 'credit' ? payment.amount : ''}</p>
            <p>{payment.type === 'debit' ? payment.amount : ''}</p>
            <p>{payment.product_type}</p>
        </>
    )
}

const WalletTable = () => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    const { wallet } = useSelector((state: RootState) => state.member)

    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        dispatch(fetchWalletHistory({ p: currentPage }))
    }, [currentPage])

    const TableHeader = () => {
        return (
            <>
                <div className={'boldValue'}>{t('Date')}</div>
                <div className={'boldValue'}>{t('Credit')}</div>
                <p className={'boldValue'}>{t('Debit')}</p>
                <p className={'boldValue'}>{t('Description')}</p>
            </>
        )
    }

    const TableTotal = ({ credit, debit }: any) => {
        return (
            <>
                <p className={'boldValue'}>{t('Total')}</p>
                <p className={'boldValue'}>{credit}</p>
                <p className={'boldValue'}>{debit}</p>
                <p></p>
            </>
        )
    }

    return (
        <>
            <div className={'walletTable'}>
                <TableHeader />
                {wallet.list && wallet.list.map((item, index) => <TableLine payment={item} key={index} />)}
                <TableTotal credit={wallet.total_credit} debit={wallet.total_debit} />
            </div>
            {wallet.list && (
                <div className={'paginationWrapper'}>
                    <Pagination
                        limit={10}
                        limitOptions={[10]}
                        maxButtons={5}
                        activePage={currentPage}
                        onChangePage={(page: number) => {
                            setCurrentPage(page)
                        }}
                        total={wallet.total_count}
                    />
                </div>
            )}
        </>
    )
}

export default WalletTable
